export const EyeGoldIcon = ({ color = "#DBBE78", size = 21, ...props }) => (
    <svg
        width={size}
        height={size * (15 / 21)}
        viewBox="0 0 21 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M10.6055 0.9375C6.23047 0.9375 2.49422 3.65875 0.980469 7.5C2.49422 11.3412 6.23047 14.0625 10.6055 14.0625C14.9805 14.0625 18.7167 11.3412 20.2305 7.5C18.7167 3.65875 14.9805 0.9375 10.6055 0.9375ZM10.6055 11.875C8.19047 11.875 6.23047 9.915 6.23047 7.5C6.23047 5.085 8.19047 3.125 10.6055 3.125C13.0205 3.125 14.9805 5.085 14.9805 7.5C14.9805 9.915 13.0205 11.875 10.6055 11.875ZM10.6055 4.875C9.15297 4.875 7.98047 6.0475 7.98047 7.5C7.98047 8.9525 9.15297 10.125 10.6055 10.125C12.058 10.125 13.2305 8.9525 13.2305 7.5C13.2305 6.0475 12.058 4.875 10.6055 4.875Z"
            fill={color}
        />
    </svg>
);
